module.exports = __webpack_public_path__ + "bfdb474cf847f0b32446fd1f0629a756.png";